export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-04.jpg'),
        title: 'ARTIFICIAL INTELLIGENCE',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'TO EMBRACE AI IS TO EMBRACE THE FUTURE',
      description: `<p style="font-size:1.5rem">Artificial intelligence is leading the innovation of global companies. Artificial Intelligence is the field that teaches computer show to do intelligent work that only people could do in the past, such as simulating human thinking processes and intelligent behaviors: learning, reasoning, and thinking etc. Machine learning and deep learning have gone from concept to reality through computer operations; in modern times artificial intelligence has made great progress in the fields of speech and image processing.
</p>`
    },
    {
      title: 'OUR ADVANTAGE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-04.jpg')+`)"></span>
      <span>Maesinfo has high level machine learning and deep learning engineers and Ph.D. professors from first-class universities, researching cutting-edge technologies and applying them to many fields, such as: medical imaging, language translation, children's education, image recognition, etc. to provide professional Artificial Intelligence solutions for your business. Using Artificial Intelligence solutions for your enterprise will help you cut labor costs, increasing the efficiency and accuracy of your business operations..</span>`
    }
  ]
}
